import omit from 'lodash-es/omit';

import { BookingArrangementVM, Travelers } from '@booking/entities/booking-arrangement';
import { BOOKING_FORM_INPUTS, TRAVELER_FORM_INPUTS } from '@booking/constants/forms.constants';
import { formatTravelerDate } from '@booking/mappers/traveler-date.mapper';
import { dobToDate } from '@ux/mappers/date.mapper';
import { TravelerItemUI } from '@pax/entities/pax-ui';
import { isEmpty, isNullOrUndefined } from '@app/util/util';

export function getBaseTravelers(
  arrangementVM: BookingArrangementVM,
  paxListUI: TravelerItemUI[] | undefined = [],
): Travelers[] {
  return arrangementVM[BOOKING_FORM_INPUTS.TRAVELERS].map((t, i) => ({
    ...cleanBaseTraveler(t),
    DOB: formatTravelerDate(dobToDate(t.DOB)),
    Phone: arrangementVM.Phone,
    Email: arrangementVM.Email,
    ...(!isEmpty(paxListUI) && paxListUI?.every(ui => !isNullOrUndefined(ui.FareId))) && { FareId: paxListUI?.[i]?.FareId },
  }));
}

function cleanBaseTraveler(t: Travelers): Travelers {
  const tName = `${t[TRAVELER_FORM_INPUTS.FIRST_NAME]} ${t[TRAVELER_FORM_INPUTS.SECOND_NAME]}`.trim();
  return omit({ ...t, [TRAVELER_FORM_INPUTS.FIRST_NAME]: tName },
    [
      TRAVELER_FORM_INPUTS.USER_ID,
      TRAVELER_FORM_INPUTS.SECOND_NAME,
      TRAVELER_FORM_INPUTS.INTERNATIONAL_DOCUMENT_REQUIRED
    ]);
}
